/* eslint-disable no-console */
import TaxInformationForm from './TaxInformationForm';
import { createCurrentUser } from '../../util/test-data';

const currentUser = createCurrentUser('tax-user', {
  profile: {
    firstName: 'Joni',
    lastName: 'Velho',
    displayName: 'Joni V',
    abbreviatedName: 'JV',
    publicData: { account_role: 'freelancer' },
  },
});

// Mimics taxToInitialValues output for a saved FI INDIVIDUAL record with a
// masked HETU and no business registration.
const initialValues = {
  country: 'FI',
  finCompanyForm: 'INDIVIDUAL_NO_BUSINESS_ID',
  finHasYtunnus: false,
  sellerType: null,
  ytunnus: '',
  hetu: '',
  tin: '',
  tinCountry: '',
  noTin: false,
  legalName: '',
  firstName: 'Joni',
  lastName: 'Velho',
  vat: '',
  companyForm: '',
  businessRegNumber: '',
  businessRegCountry: '',
  iban: 'FI2112345600000785',
  street: 'Katu 2',
  postcode: '00100',
  city: 'Helsinki',
  birthCity: '',
  birthCountry: '',
  dateOfBirth: null,
  submittedAt: '2026-07-15T00:00:00.000Z',
};

export const SavedIndividualMaskedHetu = {
  component: TaxInformationForm,
  props: {
    initialValues,
    currentUser,
    initialMaskedIdentifier: { last4: '215U', type: 'HETU' },
    onSubmit: values => {
      console.log('Submit TaxInformationForm with values:', values);
    },
    onChange: () => null,
    inProgress: false,
    taxInformationSuccess: false,
    taxInformationError: null,
  },
  group: 'forms',
};
